import { render, staticRenderFns } from "./NewsPage.vue?vue&type=template&id=31294ddc"
import script from "./NewsPage.vue?vue&type=script&lang=js"
export * from "./NewsPage.vue?vue&type=script&lang=js"
import style0 from "./NewsPage.vue?vue&type=style&index=0&id=31294ddc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports